module.exports = __webpack_public_path__ + "img/suto-article-pic.53023a96.png";